<template>
  <div ref="headerBarWrapper" data-name="header-bar-wrapper" :class="$style.wrapper">
    <div id="headerLogo" :class="$style['icon-container']">
      <logo :class="$style.logo" :ns="'header'"></logo>
    </div>
    <!-- <transition @enter="handleMoreInfoEnter">
			<div
				id="moreInfoButton"
				v-if="appState === 'playing' || appState === 'instruction' || appState === 'playing-show-card'"
				@click="handleMoreInfoClick"
				v-touch="handleMoreInfoClick"
				:class="$style['more-info-button']"
			>?</div>
    </transition>-->
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap";
import Logo from "./Logo.vue";
import isMobileMixin from "../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../plugins/tweenSpeedsMixin.js";

export default {
  name: "header-bar",
  mixins: [isMobileMixin, tweenSpeedsMixin],
  props: {},
  components: { Logo },
  data() {
    return {};
  },
  computed: {
    appState: function() {
      return this.$store.getters.getAppState;
    }
  },
  watch: {
    appState(state, oldState) {
      if (state === "instruction" || state === "playing-show-card") {
        this.handleHeaderTweenForCardOpen();

        if (this.isMobile) {
          this.handleLogoFade(true);
        }
      } else if (state === "playing" || state === "init") {
        this.handleHeaderTweenForCardClose();

        if (this.isMobile) {
          this.handleLogoFade(false);
        }
      } else if (state === "finished") {
        this.handleLogoFade(true);
      }
    }
  },
  mounted() {},
  methods: {
    handleMoreInfoClick: function() {
      if (this.appState === "instruction") {
        this.$store.dispatch("updateAppState", {
          state: "playing-show-card"
        });
      } else {
        this.$store.dispatch("updateAppState", {
          state: "instruction"
        });
      }
    },
    handleLogoFade: function(reverse) {
      TweenMax.to("#headerLogo", 0.5, {
        opacity: reverse ? 0 : 1
      });
    },
    handleMoreInfoEnter: function(el, done) {
      // console.log('el:  ', el);
      TweenMax.fromTo(
        el,
        0.5,
        {
          opacity: 0,
          ease: this.tweenSpeeds.ease.global
        },
        {
          opacity: 1,
          ease: this.tweenSpeeds.ease.global
        }
      );

      done();
    },
    handleHeaderTweenForCardOpen: function() {
      if (this.isMobile) {
      } else {
        TweenMax.to(
          this.$refs.headerBarWrapper,
          this.tweenSpeeds.dur.headerBarResize,
          {
            width: "70%",
            ease: this.tweenSpeeds.ease.global
          }
        );
      }
    },
    handleHeaderTweenForCardClose: function() {
      if (this.isMobile) {
      } else {
        TweenMax.to(
          this.$refs.headerBarWrapper,
          this.tweenSpeeds.dur.headerBarResize,
          {
            width: "100%",
            ease: this.tweenSpeeds.ease.global
          }
        );
      }
    }
  }
};
</script>



<style lang='scss' module>
@import "../assets/css/globals.scss";

* {
  // outline: 1px solid red;
}

.wrapper {
  position: absolute;
  top: 0;
  left: 50%;

  // width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  transform: translateX(-50%);

  font-family: sans-serif;
  font-weight: bold;

  z-index: 850;

  @include xxxlarge {
    height: 150px;
  }
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 150px;

  // background-color: RGBA(100, 100, 100, 0.05);

  @include large {
    display: block;

    width: 200px;

    margin-left: auto;
    margin-right: auto;
  }

  @include xxxlarge {
    width: 300px;
  }
}

.more-info-button {
  position: absolute;
  right: 0px;
  top: 30px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 45px;
  height: 45px;

  margin-right: 20px;

  border-radius: 50%;
  // border: 1px solid black;

  color: white;

  background-color: RGBA(255, 255, 255, 0.1);

  cursor: pointer;

  @include large {
    position: absolute;
    right: 0;
  }
}

.image-logo {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/components/HeaderBar.vue